export const OptionsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#212121"
      fillRule="evenodd"
      d="M8.472 2.22c.302.093.591.213.867.36l1.222-.733a.667.667 0 0 1 .814.1l.678.679a.667.667 0 0 1 .1.813l-.733 1.223c.147.275.267.564.36.866l1.382.346a.667.667 0 0 1 .505.647v.958a.666.666 0 0 1-.505.647l-1.382.346a4.957 4.957 0 0 1-.36.867l.733 1.222a.667.667 0 0 1-.1.814l-.678.678a.666.666 0 0 1-.814.1l-1.222-.733a4.957 4.957 0 0 1-.867.36l-.346 1.382a.667.667 0 0 1-.646.505h-.96a.666.666 0 0 1-.646-.505l-.346-1.382c-.3-.092-.59-.213-.866-.36l-1.223.733a.667.667 0 0 1-.813-.1l-.68-.678a.666.666 0 0 1-.1-.814l.734-1.222a5 5 0 0 1-.36-.867L.838 8.126a.667.667 0 0 1-.505-.646v-.959a.667.667 0 0 1 .505-.646l1.382-.346c.093-.302.213-.591.36-.867L1.847 3.44a.667.667 0 0 1 .1-.814l.679-.68a.667.667 0 0 1 .813-.1l1.223.734c.275-.147.564-.267.866-.36L5.874.838A.667.667 0 0 1 6.52.333h.959a.667.667 0 0 1 .647.505l.346 1.382ZM7 9.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333Z"
      clipRule="evenodd"
    />
  </svg>
);
